



























































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { Snack, SnackType } from '@/interfaces/snack'
import { Case } from '@/modules/Case/interfaces/case'
import { translateCaseTypeKey } from '@/utils/translate'
import { caseType, caseTypeClass, casePriorityClass } from '@/modules/Case/helpers/case'

@Component
export default class CaseDashboardCard extends Vue {
  @Prop() readonly caseInfo!: Case
  @Prop({ default: false }) readonly isSimple!: boolean
  @Prop({ default: '' }) readonly phase!: string
  @Prop({ default: false }) readonly isNoData!: boolean

  translateCaseTypeKey = translateCaseTypeKey
  casePriorityClass = casePriorityClass
  caseTypeClass = caseTypeClass

  get openedDays () {
    if (!this.caseInfo) {
      return ''
    }

    const { openDate, closeDate, closed } = this.caseInfo

    const closeDateM = this.$moment.unix(closeDate).tz('America/New_York')
    const openDateM = this.$moment.unix(openDate).tz('America/New_York')
    const nowM = this.$moment().tz('America/New_York')

    return closed
      ? closeDateM.diff(openDateM, 'days')
      : nowM.diff(openDateM, 'days')
  }

  get infoColor () {
    if (this.openedDays > 7) {
      return 'case-dashboard-card__info-color-red'
    }
    if (this.openedDays >= 5) {
      return 'case-dashboard-card__info-color-yellow'
    }
  }
}
